var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import Router from './pages/Router';
import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Header, Loader, Navigation } from './components';
import { useHttp } from './hooks/useHttp';
import { useMessage } from './hooks/useMessage';
import { authSlice } from './redux/reducers/AuthSlice';
import { useTypeDispatch } from './hooks/useTypeDispatch';
import { useTypeSelector } from './hooks/useTypeSelector';
import { fetchUserInfo } from './redux/action/userInfoAction';
import { LangSlice } from './redux/reducers/LangSlice';
import { fetchYear } from './redux/action/yearAction';
import { fetchSw } from './redux/action/wsAction';
import { access_dekanat, id_role_dekanat, id_role_teacher } from './config/roles';
import { url } from './config/url';
import { isReportJournal } from './redux/reducers/IsReportJournal';
import { isReportAdmission } from './redux/reducers/IsReportAdmission';
const App = () => {
    const navigate = useNavigate();
    const { hideJournalReport } = isReportJournal.actions;
    const { hideAdmissionReport } = isReportAdmission.actions;
    const { accessAuth, clearData, role3 } = authSlice.actions;
    const { is: isJournal } = useTypeSelector(state => state.isJournalReducer);
    const { is: isAddiss } = useTypeSelector(state => state.isAdmissionReducer);
    const { changeLang } = LangSlice.actions;
    const { id_avn_user, id_user, isAuth, id_role } = useTypeSelector(state => state.authReducer);
    const dispatch = useTypeDispatch();
    const toast = useMessage();
    const { request } = useHttp();
    const [mainLoader, setMainLoader] = React.useState(true);
    const [isNavigation, setIsNavigation] = React.useState(false);
    const [access, setAccess] = React.useState(null);
    const [isAccessTeacher, setIsAccess] = React.useState(null);
    const [vCheckDoc_Ins, setVCheckDoc_Ins] = useState({
        doc: '',
        ins: ''
    });
    const checkAuth = () => __awaiter(void 0, void 0, void 0, function* () {
        const { auth, data } = yield request('/auth/check');
        setMainLoader(false);
        if (auth) {
            dispatch(accessAuth({
                id_role: data.id_role,
                id_avn_user: data.id_avn_user,
                id_user: data.id_user,
                isAuth: true
            }));
        }
        navigate(`${url}/login`);
    });
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        const { message, type } = yield request('/auth/logout');
        if (type == 'success') {
            window.location.replace('/lms');
        }
        // toast(message, type)
        // dispatch(clearData())
        // if (isJournal) {
        //     dispatch(hideJournalReport())
        // }
        // if (isAddiss) {
        //     dispatch(hideAdmissionReport())
        // }
        // setAccess(null)
        // if (isNavigation) {
        //     setIsNavigation(false)
        // }
    });
    const getAccessDekanat = () => __awaiter(void 0, void 0, void 0, function* () {
        setMainLoader(true);
        const { data } = yield request(`/dekanat/access`, 'POST', {
            id_avn_user
        });
        setMainLoader(false);
        if ((data === null || data === void 0 ? void 0 : data.perm) == access_dekanat) {
            setAccess(data === null || data === void 0 ? void 0 : data.perm);
            dispatch(role3());
        }
    });
    const getAccessTeacher = () => __awaiter(void 0, void 0, void 0, function* () {
        setMainLoader(true);
        const { data } = yield request(`/teacher/access/${id_user}`);
        setMainLoader(false);
        if (data === null || data === void 0 ? void 0 : data.id_teacher) {
            setIsAccess(data === null || data === void 0 ? void 0 : data.id_teacher);
        }
    });
    const getVDocAIns = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        const { data } = yield request('/dekanat/vDocAIns');
        setVCheckDoc_Ins(Object.assign(Object.assign({}, vCheckDoc_Ins), { doc: (_a = data[0]) === null || _a === void 0 ? void 0 : _a.value, ins: (_b = data[1]) === null || _b === void 0 ? void 0 : _b.value }));
    });
    const isLang = () => {
        const l = localStorage.getItem('lang');
        switch (l) {
            case 'kg':
                dispatch(changeLang(2));
                break;
            case 'en':
                dispatch(changeLang(3));
                break;
            default:
        }
    };
    React.useEffect(() => {
        if (id_role == id_role_dekanat) {
            getAccessTeacher();
        }
    }, [id_role]);
    React.useEffect(() => {
        if (isAuth) {
            dispatch(fetchUserInfo({ id_avn_user, id_user, id_role }));
            dispatch(fetchYear());
            dispatch(fetchSw());
        }
        if (id_role == id_role_teacher) {
            getAccessDekanat();
        }
    }, [isAuth]);
    React.useEffect(() => {
        // isUp()
        const pathname = window.location.pathname;
        isLang();
        if (pathname != `${url}/token`) {
            checkAuth();
        }
        else {
            setMainLoader(false);
        }
    }, []);
    React.useEffect(() => {
        getVDocAIns();
    }, []);
    const changeMenu = (is) => {
        setIsNavigation(is);
    };
    // const isUp = () => {
    //     const up = document.querySelector('.up_') as HTMLDivElement
    //     window.addEventListener('scroll', () => {
    //         if (window.scrollY < 100) {
    //             return (up.style.display = 'none')
    //         }
    //         up.style.display = 'flex'
    //     })
    // }
    const up = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    if (mainLoader) {
        return (_jsx("div", Object.assign({ className: "vh-100 flex justify-content-center align-items-center" }, { children: _jsx(Loader, {}) })));
    }
    return (_jsxs(_Fragment, { children: [_jsx(ToastContainer, {}), _jsx(Header, { changeMenu: changeMenu, isNavigation: isNavigation }), isAuth && (_jsx(Navigation, { isAccessTeacher: isAccessTeacher, access: access, logout: logout, changeMenu: changeMenu, isNavigation: isNavigation, vCheckDoc_Ins: vCheckDoc_Ins })), isAuth && (_jsx("div", Object.assign({ onClick: up, className: "bg-color-primary position-fixed up_" }, { children: _jsx("i", { className: "fa-solid fa-arrow-up", style: { fontSize: '24px' } }) }))), _jsx(Router, { isAccessTeacher: isAccessTeacher, access: access })] }));
};
export default App;
